import type { GameObj } from "kaplay";
import { look } from "../components/look";
import { config } from "../config";
import { LOOKS, type LookKey } from "../config/assetManifest";
import { COLORS } from "../config/constants";
import type { EntityDescriptor } from "../config/types";
import { k } from "./kaplay";

type Factory = (d: EntityDescriptor) => GameObj;

const factories = new Map<string, Factory>();

export function registerEntity(type: string, factory: Factory) {
    factories.set(type, factory);
}

export function spawnEntity(d: EntityDescriptor): GameObj {
    const factory = factories.get(d.type) ?? (d.type in LOOKS ? lookEntity : unknownEntity);
    return factory(d);
}

function lookEntity(d: EntityDescriptor) {
    const flat = config.obstacles[d.type]?.kind === "region";
    const placement = flat ? [k.layer("ground"), k.z(1)] : [k.z(d.y)];
    return k.add([k.pos(d.x, d.y), look(d.type as LookKey, d.variant), ...placement, "world"]);
}

function unknownEntity(d: EntityDescriptor) {
    const box = k.add([k.rect(64, 64), k.color(COLORS.debug), k.anchor("bot"), k.pos(d.x, d.y), k.z(d.y), "world"]);
    box.add([k.text(d.type, { size: 14 }), k.anchor("center"), k.pos(0, -32), k.color(0, 0, 0)]);
    return box;
}
